const icons = {};

icons.quote = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="24" height="24" fill="white" />
  <path fill-rule="evenodd" clip-rule="evenodd" d="M17.6875 9.42857C17.6875 8.2451 16.7081 7.28571 15.5 7.28571H14.625V6H15.5C17.433 6 19 7.53502 19 9.42857V18H12.875V12.8571H17.6875V9.42857Z" fill="#1679F9" />
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.8125 9.42857C9.8125 8.2451 8.83312 7.28571 7.625 7.28571H6.75V6H7.625C9.558 6 11.125 7.53502 11.125 9.42857V18H5V12.8571H9.8125V9.42857Z" fill="#1679F9" />
</svg>



export default icons;